export const movies = [
  {
    id: "m-01",
    title: "星际回响",
    type: "movie",
    typeLabel: "电影",
    region: "大陆",
    year: 2024,
    genres: ["科幻", "冒险"],
    director: "顾承宇",
    actors: ["林见深", "苏晚棠", "贺兰川"],
    rating: 8.9,
    views: 12840000,
    duration: "138分钟",
    updatedAt: "2024-09-12",
    summary: "一支深空探测队在一颗濒临衰亡的星球上截获一段来自远古文明的信号，队长必须在返航与真相之间做出抉择。",
    tags: ["科幻", "太空", "冒险", "硬核"],
    featured: true,
    banner: "https://readdy.ai/api/search-image?query=Wide%20cinematic%20sci-fi%20backdrop%2C%20deep%20space%20nebula%20with%20a%20glowing%20ringed%20planet%20on%20the%20horizon%2C%20silhouette%20of%20an%20astronaut%20drifting%2C%20volumetric%20light%2C%20dark%20blue%20and%20violet%20tones%2C%20epic%20film%20still%2C%20high%20detail%2C%20no%20text&width=1600&height=900&seq=panda-hero-01&orientation=landscape",
    cover: "https://readdy.ai/api/search-image?query=Cinematic%20minimalist%20movie%20poster%2C%20deep%20midnight%20blue%20and%20charcoal%20gradient%20background%20with%20a%20distant%20glowing%20planet%20ring%2C%20silhouette%20of%20a%20lone%20astronaut%20drifting%20in%20vast%20space%2C%20subtle%20star%20particles%2C%20dramatic%20rim%20light%2C%20high%20contrast%20editorial%20composition%2C%20artistic%20illustration%2C%20no%20text%2C%20moody%20elegant%20atmosphere&width=400&height=600&seq=panda-poster-01&orientation=portrait",
  },
  {
    id: "m-02",
    title: "无声证词",
    type: "movie",
    typeLabel: "电影",
    region: "大陆",
    year: 2023,
    genres: ["悬疑", "剧情"],
    director: "岑书禾",
    actors: ["周砚清", "许星野", "柳知微"],
    rating: 8.4,
    views: 9630000,
    duration: "124分钟",
    updatedAt: "2023-11-03",
    summary: "一名失聪的目击者成为连环谜案的唯一线索，年轻刑警在无声的世界里拼凑出被刻意掩盖的真相。",
    tags: ["悬疑", "犯罪", "推理", "剧情"],
    cover: "https://readdy.ai/api/search-image?query=Atmospheric%20thriller%20movie%20poster%2C%20dark%20teal%20and%20black%20gradient%20background%2C%20blurred%20silhouette%20of%20a%20rain-soaked%20city%20street%20at%20night%2C%20single%20glowing%20streetlamp%2C%20heavy%20fog%20and%20reflections%20on%20wet%20pavement%2C%20cinematic%20suspense%20mood%2C%20high%20contrast%2C%20artistic%20illustration%20style%2C%20no%20text&width=400&height=600&seq=panda-poster-02&orientation=portrait",
  },
  {
    id: "m-03",
    title: "霓虹追缉",
    type: "movie",
    typeLabel: "电影",
    region: "港台",
    year: 2024,
    genres: ["动作", "犯罪"],
    director: "韦世昌",
    actors: ["陈柏川", "黎子墨", "许安琪"],
    rating: 8.1,
    views: 10420000,
    duration: "116分钟",
    updatedAt: "2024-07-28",
    summary: "退役特工为护送一枚加密芯片穿越整座不夜城，在霓虹与雨幕之间展开一场步步惊心的追逐。",
    tags: ["动作", "犯罪", "追车", "港风"],
    featured: true,
    banner: "https://readdy.ai/api/search-image?query=Wide%20cinematic%20action%20backdrop%2C%20neon-lit%20rainy%20city%20alley%20with%20magenta%20and%20cyan%20reflections%2C%20silhouette%20in%20motion%2C%20dramatic%20atmosphere%2C%20cyberpunk%20film%20still%2C%20high%20contrast%2C%20no%20text&width=1600&height=900&seq=panda-hero-03&orientation=landscape",
    cover: "https://readdy.ai/api/search-image?query=Stylish%20action%20movie%20poster%2C%20dark%20background%20with%20vivid%20magenta%20and%20cyan%20neon%20glow%2C%20silhouette%20of%20a%20running%20figure%20between%20neon%20light%20streaks%2C%20rainy%20reflective%20alleyway%2C%20dynamic%20motion%20blur%2C%20cinematic%20cyberpunk%20mood%2C%20high%20contrast%20editorial%20illustration%2C%20no%20text&width=400&height=600&seq=panda-poster-03&orientation=portrait",
  },
  {
    id: "m-04",
    title: "山海邮局",
    type: "movie",
    typeLabel: "电影",
    region: "大陆",
    year: 2022,
    genres: ["奇幻", "剧情"],
    director: "温子砚",
    actors: ["沈知白", "白露微", "叶清舟"],
    rating: 8.7,
    views: 7310000,
    duration: "129分钟",
    updatedAt: "2022-12-19",
    summary: "一间开在山海之间的老邮局，能寄出写给过去的信，也让一位失信于人间的老人找回了未寄出的告别。",
    tags: ["奇幻", "温情", "治愈", "剧情"],
    cover: "https://readdy.ai/api/search-image?query=Warm%20fantasy%20drama%20movie%20poster%2C%20soft%20golden%20and%20deep%20green%20gradient%20background%2C%20tiny%20floating%20paper%20letters%20drifting%20over%20misty%20mountains%20at%20dawn%2C%20delicate%20light%20rays%2C%20nostalgic%20dreamy%20atmosphere%2C%20painterly%20illustration%2C%20high%20detail%2C%20no%20text&width=400&height=600&seq=panda-poster-04&orientation=portrait",
  },
  {
    id: "m-05",
    title: "午夜面包店",
    type: "movie",
    typeLabel: "电影",
    region: "日本",
    year: 2023,
    genres: ["爱情", "剧情"],
    director: "藤井和也",
    actors: ["佐野真纪", "高桥悠斗", "小林里奈"],
    rating: 8.3,
    views: 6420000,
    duration: "112分钟",
    updatedAt: "2023-05-21",
    summary: "只在深夜营业的面包店里，两位习惯失眠的陌生人用一个个温热的夜晚，慢慢治愈彼此的遗憾。",
    tags: ["爱情", "治愈", "都市", "日系"],
    cover: "https://readdy.ai/api/search-image?query=Cozy%20romantic%20movie%20poster%2C%20warm%20amber%20and%20cream%20gradient%20background%2C%20soft%20glow%20from%20a%20small%20bakery%20window%20in%20a%20quiet%20night%20street%2C%20steam%20rising%20from%20fresh%20bread%2C%20gentle%20bokeh%20lights%2C%20tender%20nostalgic%20mood%2C%20painterly%20illustration%2C%20high%20detail%2C%20no%20text&width=400&height=600&seq=panda-poster-05&orientation=portrait",
  },
  {
    id: "m-06",
    title: "荒原旅人",
    type: "movie",
    typeLabel: "电影",
    region: "美国",
    year: 2024,
    genres: ["冒险", "剧情"],
    director: "Ethan Cole",
    actors: ["Marcus Reed", "Nora Hale", "Dylan Vega"],
    rating: 8.0,
    views: 5980000,
    duration: "141分钟",
    updatedAt: "2024-06-08",
    summary: "一名沉默的旅人带着一张残破的地图穿越无人荒原，只为把一封信送到传说中早已消失的小镇。",
    tags: ["冒险", "公路", "生存", "剧情"],
    cover: "https://readdy.ai/api/search-image?query=Epic%20adventure%20movie%20poster%2C%20dusty%20orange%20and%20slate%20gray%20gradient%20background%2C%20lone%20traveler%20silhouette%20walking%20a%20vast%20desert%20canyon%20ridge%20under%20a%20huge%20sun%2C%20wind-blown%20dust%2C%20dramatic%20scale%2C%20cinematic%20editorial%20illustration%2C%20high%20contrast%2C%20no%20text&width=400&height=600&seq=panda-poster-06&orientation=portrait",
  },
  {
    id: "m-07",
    title: "时光折叠",
    type: "movie",
    typeLabel: "电影",
    region: "美国",
    year: 2022,
    genres: ["科幻", "悬疑"],
    director: "Ava Sinclair",
    actors: ["Julian Frost", "Clara Boone", "Leo Marsh"],
    rating: 8.6,
    views: 8870000,
    duration: "127分钟",
    updatedAt: "2022-08-15",
    summary: "物理学家发现时间可以像纸一样被折叠，为了救回意外身故的妹妹，他一次次重写同一个下午。",
    tags: ["科幻", "时间", "悬疑", "烧脑"],
    featured: true,
    banner: "https://readdy.ai/api/search-image?query=Wide%20cinematic%20suspense%20backdrop%2C%20foggy%20city%20skyline%20at%20night%20with%20a%20single%20lit%20window%2C%20cold%20gray-green%20tones%2C%20mysterious%20mood%2C%20film%20still%2C%20high%20contrast%2C%20no%20text&width=1600&height=900&seq=panda-hero-05&orientation=landscape",
    cover: "https://readdy.ai/api/search-image?query=Conceptual%20sci-fi%20movie%20poster%2C%20deep%20indigo%20and%20violet-black%20gradient%20background%2C%20abstract%20folding%20ribbons%20of%20light%20forming%20a%20clock-like%20spiral%2C%20glowing%20particles%2C%20futuristic%20minimal%20composition%2C%20high%20contrast%20editorial%20illustration%2C%20no%20text&width=400&height=600&seq=panda-poster-07&orientation=portrait",
  },
  {
    id: "m-08",
    title: "棋局之外",
    type: "movie",
    typeLabel: "电影",
    region: "韩国",
    year: 2023,
    genres: ["剧情", "悬疑"],
    director: "Park Ji-hoon",
    actors: ["Kang Seo-yeon", "Yoon Tae-min", "Han Ji-woo"],
    rating: 8.5,
    views: 5240000,
    duration: "119分钟",
    updatedAt: "2023-09-30",
    summary: "天才棋手在一场决定命运的决赛中突然弃权，多年后一局旧棋谱揭开了当年那场沉默背后的惊天秘密。",
    tags: ["剧情", "悬疑", "人性", "韩系"],
    cover: "https://readdy.ai/api/search-image?query=Tense%20drama%20movie%20poster%2C%20muted%20charcoal%20and%20warm%20ivory%20gradient%20background%2C%20a%20single%20chess%20piece%20and%20a%20chessboard%20half%20in%20shadow%2C%20dramatic%20side%20lighting%2C%20quiet%20suspense%20mood%2C%20minimal%20cinematic%20illustration%2C%20high%20detail%2C%20no%20text&width=400&height=600&seq=panda-poster-08&orientation=portrait",
  },
  {
    id: "m-09",
    title: "雪国列车站",
    type: "movie",
    typeLabel: "电影",
    region: "欧洲",
    year: 2021,
    genres: ["悬疑", "剧情"],
    director: "Lars Berg",
    actors: ["Ingrid Falk", "Matteo Rossi", "Sofia Lind"],
    rating: 8.2,
    views: 4120000,
    duration: "133分钟",
    updatedAt: "2021-11-26",
    summary: "暴雪封站，滞留的旅客中少了一个人，而站台广播却在深夜重复着一个早已离世的名字。",
    tags: ["悬疑", "北欧", "人性", "剧情"],
    cover: "https://readdy.ai/api/search-image?query=Cold%20mystery%20movie%20poster%2C%20pale%20blue-gray%20and%20dark%20navy%20gradient%20background%2C%20abandoned%20snow-covered%20train%20station%20at%20dusk%2C%20distant%20lone%20figure%20with%20a%20lantern%2C%20falling%20snow%2C%20melancholic%20cinematic%20mood%2C%20painterly%20illustration%2C%20no%20text&width=400&height=600&seq=panda-poster-09&orientation=portrait",
  },
  {
    id: "m-10",
    title: "夏日狂欢曲",
    type: "movie",
    typeLabel: "电影",
    region: "大陆",
    year: 2024,
    genres: ["喜剧", "爱情"],
    director: "钱多乐",
    actors: ["方一诺", "唐小满", "郑好"],
    rating: 7.6,
    views: 6890000,
    duration: "105分钟",
    updatedAt: "2024-08-02",
    summary: "一场乌龙误会让三个互不相识的年轻人被迫合伙经营海边民宿，整个夏天笑料与心动接连不断。",
    tags: ["喜剧", "夏日", "轻松", "爱情"],
    cover: "https://readdy.ai/api/search-image?query=Bright%20comedy%20movie%20poster%2C%20cheerful%20coral%20and%20sunny%20yellow%20gradient%20background%2C%20playful%20abstract%20shapes%20of%20beach%20balls%20and%20sunglasses%2C%20confetti%20burst%2C%20energetic%20summer%20vibes%2C%20flat%20editorial%20illustration%2C%20high%20contrast%2C%20no%20text&width=400&height=600&seq=panda-poster-10&orientation=portrait",
  },
  {
    id: "m-11",
    title: "深海信使",
    type: "movie",
    typeLabel: "电影",
    region: "大陆",
    year: 2023,
    genres: ["动画", "奇幻"],
    director: "苏望舒",
    actors: ["配音：夏言", "配音：陆铭", "配音：许诺"],
    rating: 8.8,
    views: 7920000,
    duration: "98分钟",
    updatedAt: "2023-07-14",
    summary: "一只胆小的小鲸鱼为了把海洋的心愿送到海面，踏上穿越深海传说禁地的奇幻旅程，结识了一群意想不到的伙伴。",
    tags: ["动画", "奇幻", "合家欢", "治愈"],
    featured: true,
    banner: "https://readdy.ai/api/search-image?query=Wide%20cinematic%20underwater%20backdrop%2C%20glowing%20bioluminescent%20jellyfish%20and%20coral%20reef%2C%20a%20small%20whale%20swimming%20through%20rays%20of%20light%2C%20aqua%20and%20emerald%20tones%2C%20dreamy%20film%20still%2C%20no%20text&width=1600&height=900&seq=panda-hero-04&orientation=landscape",
    cover: "https://readdy.ai/api/search-image?query=Enchanting%20animation%20movie%20poster%2C%20deep%20aqua%20and%20emerald%20gradient%20background%2C%20glowing%20jellyfish%20and%20a%20small%20brave%20whale%20swimming%20through%20coral%20arches%2C%20bioluminescent%20lights%2C%20whimsical%20painterly%20illustration%2C%20high%20detail%2C%20no%20text&width=400&height=600&seq=panda-poster-11&orientation=portrait",
  },
  {
    id: "m-12",
    title: "铁血黎明",
    type: "movie",
    typeLabel: "电影",
    region: "美国",
    year: 2021,
    genres: ["战争", "剧情"],
    director: "Samuel Grant",
    actors: ["Owen Pierce", "Riley Quinn", "Adam Cross"],
    rating: 7.9,
    views: 4560000,
    duration: "145分钟",
    updatedAt: "2021-10-05",
    summary: "一支小队在撤退途中被困于无名高地，黎明前的最后几小时里,他们必须守住的不只是阵地。",
    tags: ["战争", "剧情", "群像", "历史"],
    cover: "https://readdy.ai/api/search-image?query=Intense%20war%20movie%20poster%2C%20smoky%20charcoal%20and%20dark%20crimson%20gradient%20background%2C%20silhouettes%20of%20soldiers%20advancing%20through%20morning%20fog%20at%20dawn%2C%20single%20ray%20of%20light%2C%20heavy%20grain%20texture%2C%20cinematic%20illustration%2C%20high%20contrast%2C%20no%20text&width=400&height=600&seq=panda-poster-12&orientation=portrait",
  },
  {
    id: "m-13",
    title: "长安夜行录",
    type: "tv",
    typeLabel: "电视剧",
    region: "大陆",
    year: 2024,
    genres: ["古装", "悬疑"],
    director: "裴无名",
    actors: ["谢云归", "姜雨棠", "裴照"],
    rating: 9.0,
    views: 24310000,
    duration: "全36集",
    updatedAt: "2024-09-25",
    summary: "长安城接连发生离奇命案，落魄书生与冷面护卫被迫联手，在灯火辉煌的夜色下追查一桩跨越十年的旧案。",
    tags: ["古装", "悬疑", "探案", "权谋"],
    featured: true,
    banner: "https://readdy.ai/api/search-image?query=Wide%20cinematic%20ancient%20China%20backdrop%2C%20misty%20lantern-lit%20ancient%20street%20at%20night%20under%20a%20full%20moon%2C%20ink-wash%20mountains%20far%20behind%2C%20warm%20gold%20and%20deep%20black%20tones%2C%20epic%20period%20film%20still%2C%20no%20text&width=1600&height=900&seq=panda-hero-02&orientation=landscape",
    cover: "https://readdy.ai/api/search-image?query=Ancient%20Chinese%20costume%20drama%20poster%2C%20ink-wash%20black%20and%20warm%20gold%20gradient%20background%2C%20silhouette%20of%20a%20robed%20figure%20walking%20a%20lantern-lit%20ancient%20street%20under%20a%20full%20moon%2C%20drifting%20mist%2C%20elegant%20Chinese%20painting%20style%2C%20high%20detail%2C%20no%20text&width=400&height=600&seq=panda-poster-13&orientation=portrait",
    episodes: [
      { index: 1, title: "第1集 · 雨夜血案", summary: "长安城大雨之夜，一名商人之死揭开了平静表象下的暗流。", duration: "45分钟" },
      { index: 2, title: "第2集 · 灯下人", summary: "谢云归在灯市偶遇线索，却发现自己早已被人盯上。", duration: "44分钟" },
      { index: 3, title: "第3集 · 旧案重启", summary: "一份尘封卷宗牵出十年前的悬案，两人的合作正式开始。", duration: "46分钟" },
      { index: 4, title: "第4集 · 夜探西坊", summary: "夜探废弃西坊，一个不起眼的印记成为关键转折。", duration: "45分钟" },
      { index: 5, title: "第5集 · 真假书生", summary: "有人冒用谢云归的身份行动，长安城陷入更大的迷局。", duration: "44分钟" },
      { index: 6, title: "第6集 · 灯火深处", summary: "真相近在眼前，却触碰到了谁也不敢提及的名字。", duration: "47分钟" },
    ],
  },
  {
    id: "m-14",
    title: "迷雾档案",
    type: "tv",
    typeLabel: "电视剧",
    region: "大陆",
    year: 2023,
    genres: ["悬疑", "犯罪"],
    director: "罗清野",
    actors: ["秦屹", "白榆", "程亦然"],
    rating: 8.7,
    views: 18650000,
    duration: "全24集",
    updatedAt: "2023-12-11",
    summary: "一座沿海小城连续出现失踪案，档案室里被撕掉的几页旧卷宗，指向一个仍在暗处运转的秘密。",
    tags: ["悬疑", "犯罪", "刑侦", "群像"],
    cover: "https://readdy.ai/api/search-image?query=Suspense%20series%20poster%2C%20cold%20gray-green%20and%20near-black%20gradient%20background%2C%20scattered%20case%20files%20and%20a%20magnifying%20glass%20over%20blurred%20faces%2C%20single%20harsh%20light%20beam%2C%20mysterious%20investigative%20mood%2C%20editorial%20illustration%2C%20no%20text&width=400&height=600&seq=panda-poster-14&orientation=portrait",
    episodes: [
      { index: 1, title: "第1集 · 潮声", summary: "小城停港之夜，第一个报案人带来了不合常理的证词。", duration: "42分钟" },
      { index: 2, title: "第2集 · 空白页", summary: "档案室中缺失的卷宗，让调查方向彻底改变。", duration: "41分钟" },
      { index: 3, title: "第3集 · 旧灯塔", summary: "废弃灯塔里留下的痕迹，串联起数起看似无关的失踪。", duration: "43分钟" },
      { index: 4, title: "第4集 · 证人", summary: "唯一的目击者突然翻供，让案情陷入僵局。", duration: "42分钟" },
      { index: 5, title: "第5集 · 逆流", summary: "秦屹决定绕开常规路径，独自追查一条被忽略的线索。", duration: "44分钟" },
      { index: 6, title: "第6集 · 暗涌", summary: "真相逐渐浮出水面，代价却比想象中更加沉重。", duration: "43分钟" },
    ],
  },
  {
    id: "m-15",
    title: "心跳频率",
    type: "tv",
    typeLabel: "电视剧",
    region: "韩国",
    year: 2024,
    genres: ["爱情", "都市"],
    director: "Lee Ha-eun",
    actors: ["Jung Soo-a", "Kim Do-yun", "Bae Hyun"],
    rating: 8.2,
    views: 20340000,
    duration: "全16集",
    updatedAt: "2024-08-19",
    summary: "一位心跳过速的急诊医生遇见了总能让她心跳平稳的神秘唱片店老板，两个习惯孤独的人开始了一段缓慢的心动。",
    tags: ["爱情", "都市", "治愈", "韩剧"],
    cover: "https://readdy.ai/api/search-image?query=Romantic%20urban%20series%20poster%2C%20soft%20pink%20and%20warm%20beige%20gradient%20background%2C%20two%20overlapping%20silhouettes%20under%20falling%20cherry%20blossoms%20on%20a%20city%20rooftop%2C%20glowing%20bokeh%20lights%2C%20tender%20atmosphere%2C%20painterly%20illustration%2C%20no%20text&width=400&height=600&seq=panda-poster-15&orientation=portrait",
    episodes: [
      { index: 1, title: "第1集 · 一次意外的心跳", summary: "深夜急诊室，两条平行的人生因为一张旧唱片交叠。", duration: "62分钟" },
      { index: 2, title: "第2集 · 唱针落下的瞬间", summary: "唱片店里的一首老歌，让两人第一次认真谈起了过去。", duration: "60分钟" },
      { index: 3, title: "第3集 · 雨中的伞", summary: "一场突如其来的暴雨，把说不出口的话都挡在了伞下。", duration: "61分钟" },
      { index: 4, title: "第4集 · 频率相近的人", summary: "工作与生活的压力，让两颗靠近的心第一次产生分歧。", duration: "60分钟" },
      { index: 5, title: "第5集 · 未寄出的信", summary: "一封没有寄出的信，揭开了彼此隐藏多年的伤口。", duration: "62分钟" },
      { index: 6, title: "第6集 · 同样的心跳", summary: "在彼此的频率里，他们终于学会了如何并肩。", duration: "63分钟" },
    ],
  },
  {
    id: "m-16",
    title: "律政先锋",
    type: "tv",
    typeLabel: "电视剧",
    region: "港台",
    year: 2022,
    genres: ["剧情", "律政"],
    director: "麦启明",
    actors: ["何冠廷", "叶咏诗", "卓家豪"],
    rating: 8.4,
    views: 15480000,
    duration: "全40集",
    updatedAt: "2022-09-08",
    summary: "一群理想主义的年轻律师在一桩桩棘手案件中坚守底线，也逐渐看清了法庭之外更复杂的人性与规则。",
    tags: ["剧情", "律政", "职场", "港剧"],
    cover: "https://readdy.ai/api/search-image?query=Legal%20drama%20series%20poster%2C%20deep%20navy%20and%20cool%20gray%20gradient%20background%2C%20silhouette%20of%20a%20figure%20in%20a%20suit%20standing%20before%20tall%20courthouse%20columns%2C%20dramatic%20light%20through%20windows%2C%20serious%20cinematic%20mood%2C%20editorial%20illustration%2C%20no%20text&width=400&height=600&seq=panda-poster-16&orientation=portrait",
    episodes: [
      { index: 1, title: "第1集 · 第一场辩护", summary: "新人律师接手的第一桩案子，对手竟是自己的导师。", duration: "43分钟" },
      { index: 2, title: "第2集 · 沉默的证人", summary: "关键证人的迟疑，让案件的走向变得扑朔迷离。", duration: "42分钟" },
      { index: 3, title: "第3集 · 规则的缝隙", summary: "当程序正义与结果正义冲突时，他们必须做出选择。", duration: "44分钟" },
      { index: 4, title: "第4集 · 旧案重审", summary: "一桩十年前的错判被重新翻开，牵动整个事务所。", duration: "43分钟" },
      { index: 5, title: "第5集 · 底线", summary: "面对巨大的压力，有人坚守，也有人动摇。", duration: "45分钟" },
      { index: 6, title: "第6集 · 结案陈词", summary: "最后一场庭审，所有人都在为自己的信念发声。", duration: "46分钟" },
    ],
  },
  {
    id: "m-17",
    title: "硅谷迷航",
    type: "tv",
    typeLabel: "电视剧",
    region: "美国",
    year: 2023,
    genres: ["剧情", "科技"],
    director: "Nathan Brooks",
    actors: ["Evan Cole", "Mia Tran", "Oscar Lin"],
    rating: 8.5,
    views: 11720000,
    duration: "全10集",
    updatedAt: "2023-06-27",
    summary: "一家濒临破产的初创公司赌上全部推出新产品，却在上市前夕发现代码深处藏着一个足以颠覆行业秘密。",
    tags: ["剧情", "科技", "创业", "美剧"],
    cover: "https://readdy.ai/api/search-image?query=Tech%20thriller%20series%20poster%2C%20dark%20slate%20and%20electric%20cyan%20gradient%20background%2C%20abstract%20circuit%20lines%20forming%20a%20maze%20around%20a%20lone%20silhouette%2C%20neon%20glow%2C%20minimal%20futuristic%20composition%2C%20editorial%20illustration%2C%20no%20text&width=400&height=600&seq=panda-poster-17&orientation=portrait",
    episodes: [
      { index: 1, title: "第1集 · 上线倒计时", summary: "产品发布进入倒计时，团队却在内部分崩离析的边缘。", duration: "52分钟" },
      { index: 2, title: "第2集 · 一行代码", summary: "一次随机的日志排查，暴露出不该存在的数据调用。", duration: "50分钟" },
      { index: 3, title: "第3集 · 投资人", summary: "融资谈判桌上，各方的真实意图开始显露。", duration: "51分钟" },
      { index: 4, title: "第4集 · 内部告密", summary: "有人把消息卖给了对手，团队之间的信任濒临瓦解。", duration: "50分钟" },
      { index: 5, title: "第5集 · 深夜会议", summary: "一场通宵会议，让所有人必须重新审视自己的底线。", duration: "53分钟" },
      { index: 6, title: "第6集 · 迷航", summary: "当真相与利益相撞，谁还愿意为最初的想法坚持。", duration: "52分钟" },
    ],
  },
  {
    id: "m-18",
    title: "江湖食肆",
    type: "tv",
    typeLabel: "电视剧",
    region: "大陆",
    year: 2024,
    genres: ["古装", "喜剧"],
    director: "郝有味",
    actors: ["柳三斤", "花小满", "孟常客"],
    rating: 8.6,
    views: 17930000,
    duration: "全30集",
    updatedAt: "2024-10-06",
    summary: "退隐的大厨在江湖路口开了一间小食肆，形形色色的过客带着各自的秘密与烦恼，在一饭一菜间化解恩怨。",
    tags: ["古装", "喜剧", "美食", "治愈"],
    cover: "https://readdy.ai/api/search-image?query=Warm%20ancient%20comedy%20series%20poster%2C%20earthy%20brown%20and%20soft%20gold%20gradient%20background%2C%20lively%20lantern-lit%20tavern%20with%20steam%20from%20steaming%20bowls%2C%20playful%20silhouettes%2C%20cozy%20folk%20atmosphere%2C%20painterly%20Chinese%20illustration%2C%20high%20detail%2C%20no%20text&width=400&height=600&seq=panda-poster-18&orientation=portrait",
    episodes: [
      { index: 1, title: "第1集 · 开张", summary: "退隐大厨的小食肆开张，第一位客人却带着一身麻烦。", duration: "42分钟" },
      { index: 2, title: "第2集 · 一碗阳春面", summary: "一碗最普通的面，解开了一对兄弟多年的心结。", duration: "41分钟" },
      { index: 3, title: "第3集 · 夜半来客", summary: "深夜上门的蒙面客，只为尝一口记忆里的味道。", duration: "43分钟" },
      { index: 4, title: "第4集 · 招牌之争", summary: "对街新开的大酒楼，掀起了小食肆的一场危机。", duration: "42分钟" },
      { index: 5, title: "第5集 · 江湖旧事", summary: "一位老友的到来，让大厨不得不再度面对江湖。", duration: "44分钟" },
      { index: 6, title: "第6集 · 团圆饭", summary: "一场意外的团圆饭，让所有过客都成了归人。", duration: "43分钟" },
    ],
  },
  {
    id: "m-19",
    title: "极地救援",
    type: "tv",
    typeLabel: "电视剧",
    region: "美国",
    year: 2022,
    genres: ["动作", "冒险"],
    director: "Grace Coleman",
    actors: ["Cole Barrett", "Ivy Nash", "Rhys Dalton"],
    rating: 8.1,
    views: 9320000,
    duration: "全12集",
    updatedAt: "2022-04-16",
    summary: "一支极地救援队在地球最寒冷的地方执行任务，每一次出发都是在与时间和极限对抗。",
    tags: ["动作", "冒险", "灾难", "群像"],
    cover: "https://readdy.ai/api/search-image?query=Arctic%20rescue%20action%20poster%2C%20icy%20white-blue%20and%20dark%20steel%20gradient%20background%2C%20helicopter%20silhouette%20over%20frozen%20cliffs%20and%20a%20vast%20glacier%2C%20snowstorm%20streaks%2C%20dramatic%20scale%2C%20cinematic%20editorial%20illustration%2C%20no%20text&width=400&height=600&seq=panda-poster-19&orientation=portrait",
    episodes: [
      { index: 1, title: "第1集 · 出发", summary: "接到求救信号，救援队在暴风雪中紧急出发。", duration: "48分钟" },
      { index: 2, title: "第2集 · 白盲", summary: "风雪遮蔽了视线，队员之间的信任受到考验。", duration: "47分钟" },
      { index: 3, title: "第3集 · 冰裂缝", summary: "穿越冰原时突发意外，救援变成了自救。", duration: "49分钟" },
      { index: 4, title: "第4集 · 无线电", summary: "断联之后，一段微弱的信号成了唯一的希望。", duration: "48分钟" },
      { index: 5, title: "第5集 · 长夜", summary: "极夜之中，队员们必须撑到救援到来的那一刻。", duration: "50分钟" },
      { index: 6, title: "第6集 · 归途", summary: "任务完成，但每个人心里都留下了极地的印记。", duration: "49分钟" },
    ],
  },
  {
    id: "m-20",
    title: "云端日记",
    type: "tv",
    typeLabel: "电视剧",
    region: "日本",
    year: 2023,
    genres: ["青春", "爱情"],
    director: "中村悠介",
    actors: ["石川凛", "山下优真", "冈本葵"],
    rating: 8.3,
    views: 8460000,
    duration: "全12集",
    updatedAt: "2023-03-24",
    summary: "两个总在天台相遇的学生，约定把想说的话写进同一本日记，一年后连同青春一起交还给彼此。",
    tags: ["青春", "校园", "爱情", "治愈"],
    cover: "https://readdy.ai/api/search-image?query=Gentle%20youth%20series%20poster%2C%20sky%20blue%20and%20soft%20white%20gradient%20background%2C%20two%20silhouettes%20on%20a%20school%20rooftop%20under%20drifting%20clouds%2C%20paper%20plane%20flying%2C%20warm%20nostalgic%20light%2C%20painterly%20illustration%2C%20high%20detail%2C%20no%20text&width=400&height=600&seq=panda-poster-20&orientation=portrait",
    episodes: [
      { index: 1, title: "第1集 · 天台的风", summary: "开学第一天，两个陌生人在天台分享了同一片云。", duration: "40分钟" },
      { index: 2, title: "第2集 · 第一行字", summary: "一本共用的日记，成了他们之间心照不宣的秘密。", duration: "39分钟" },
      { index: 3, title: "第3集 · 夏日祭", summary: "热闹的夏日祭上，有些话终于不再只写在纸上。", duration: "41分钟" },
      { index: 4, title: "第4集 · 广播站", summary: "一次校园广播，让两人的关系被所有人看见。", duration: "40分钟" },
      { index: 5, title: "第5集 · 雨季", summary: "雨季带来了误解，也带来了迟到的坦白。", duration: "41分钟" },
      { index: 6, title: "第6集 · 交还", summary: "一年之约到期，日记最后一页写满了答案。", duration: "42分钟" },
    ],
  },
];